// mobile detection
export const isMobile = window.matchMedia('only screen and (max-width: 600px)').matches
const ua = navigator.userAgent
const androidRegex = RegExp('Android')
const chromeVersionRegex = RegExp('Chrome/[.0-9]* Mobile')
export const isChrome = (androidRegex.test(ua) && chromeVersionRegex.test(ua))
export const canShare = (isMobile && isChrome)
